import React, {useState} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
const config = require('../config.json');

const PdfViewing= ({ data, url }) =>  {
const selectedItem = data;
  const [show, setShow] = useState(false);


    return (
    <div>


      <Button variant="primary" onClick={() => setShow(true)}>
        View PDF
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        fullscreen={true}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
           {selectedItem.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <iframe
            src={url}
            title="PDF Viewer"
            width="100%"
            height="100%" // Adjust height as needed
            style={{ border: 'none' }} // Optional: remove iframe border
          >
            <p>{`${config.s3.imageUrl}website/reports/${selectedItem.prgID}/${selectedItem.reportID}/${selectedItem.pdfFileName}`}</p>
            Your browser does not support iframes.
          </iframe>
        </Modal.Body>
      </Modal>


        
    </div>
  )
};
export default PdfViewing ;